import { useEffect, useState } from 'react';

/**
 * Get whether the window is mobile
 * @returns {boolean}
 */
export const getIsMobile = (): boolean => window.innerWidth <= 768;

/**
 * Hook to get whether the window is mobile
 * @returns {boolean}
 */
export const useIsMobile = (): boolean => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    window.addEventListener('resize', handleWindowResize);

    return () => {
      window.removeEventListener('resize', handleWindowResize);
    };
  });

  const handleWindowResize = () => {
    setIsMobile(getIsMobile());
  };

  return isMobile;
};
